import styled from "@emotion/styled";
import { color } from "metabase/lib/colors";

export const DrillRoot = styled.div`
  max-width: 10.75rem;
`;

export const DrillMessage = styled.div`
  color: ${color("text-dark")};
  font-weight: bold;
  line-height: 1.5rem;
`;
